import { DatePipe } from "@angular/common";
import { Component, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../../core/pipes";
import { ProgressIndicatorComponent } from "../../../../../shared/components";
import { PictureComponent } from "../../../../../shared/components/general/picture/picture";
import { Constants } from "../../../../../shared/constants/constants";
import type { NationalStrategyModelType } from "../../../../../shared/models";

@Component({
  selector: "adaa-strategy-card",
  templateUrl: "./strategy-card.html",
  styleUrl: "./strategy-card.scss",
  imports: [TranslatePipe, TranslateTokenPipe, DatePipe, ProgressIndicatorComponent, PictureComponent],
})
export class StrategyCardComponent {
  strategy = input.required<NationalStrategyModelType>();
  showAllStrategies = input<boolean>(false);

  public getColor(code: "COMPLETED" | "ON_GOING" | "DELAYED") {
    switch (code) {
      case "COMPLETED":
        return Constants.CONSTANT_COLORS.EVALUATION_LIME;
      case "ON_GOING":
        return Constants.CONSTANT_COLORS.EVALUATION_BLUE;
      case "DELAYED":
        return Constants.CONSTANT_COLORS.EVALUATION_GRAY;
    }
  }
}
